/**
 * Create Auth context for custom hook
 */

import { createContext } from 'react'
import uuidv4 from 'uuid/v4'

const AuthContext = createContext({
  authToken: '',
  deviceUdid: uuidv4(),
  userId: '',
  // handler function
  resetCounterSmsToken: () => {},
  setAuth: () => {},
  setAuthToken: () => {},
  setDeviceUdid: () => {},
  setUserId: () => {},
  signIn: () => {},
  signOut: () => {},
  deleteAuthenticationsByProvider: () => {}
})

export default AuthContext
